/**
 * Score component.
 */
import Container from '@components/atoms/container/RatingContainer';
import Denominator from '@components/atoms/text/scoreDenominator';
import Icon from '@components/atoms/icons/star';
import Numerator from '@components/atoms/text/scoreNumerator';

/**
 * Props for the Score component.
 *
 * @param {number} margin - Margin for the container
 * @param {string} score - Score to display
 */
interface Props {
  margin?: number;
  score?: string;
}

/**
 * Renders the score component.
 *
 * @returns {JSX.Element} Score component
 */
export default function Score({ score }: Props) {
  return score ? (
    <Container id='score'>
      <Icon />
      <Numerator id='scoreText'>{score}</Numerator>
      <Denominator>{'/ 5'}</Denominator>
    </Container>
  ) : null;
}
